import { render } from "./refund-request.vue?vue&type=template&id=0c986f2b"
import script from "./refund-request.vue?vue&type=script&lang=js"
export * from "./refund-request.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__